import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from 'react-router-dom'
import "./CareerInner.css";
import axios from "axios";
import {
    IoMdAttach
} from "react-icons/io";
import { set } from "date-fns";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'

function CareerInner() {


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { job_id } = useParams();
    const [data, setData] = useState([]);
    const [Data1, setData1] = useState([]);
    const [mapData1, setMapdata1] = useState([]);
    const [mapData, setMapdata] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);

    const [resume, setresume] = useState('');



    const [file, setfile] = useState('');
    const [filename, setfilename] = useState('');
    const [fileerror, setfileerror] = useState('');

    const [fullname, setfullname] = useState('');
    const [fullnameerror, setfullnameerror] = useState('');

    const [email, setemail] = useState('');
    const [emailerror, setemailerror] = useState('');


    const [mobile, setmobile] = useState('');
    const [mobileerror, setmobileerror] = useState('');

    const [qualification, setqualification] = useState('');
    const [qualificationerror, setqualificationerror] = useState('');


    const [linkdin_url, setlinkdin_url] = useState('');
    const [github_url, setgithub_url] = useState('');
    const [other_website, setother_website] = useState('');



    const [aboutself, setaboutself] = useState('');
    const [aboutselferror, setaboutselferror] = useState('');

    const [current_comp, setcurrent_comp] = useState('');
    const [current_comperror, setcurrent_comperror] = useState('');

    const [experince, setexperince] = useState('');
    const [experinceerror, setexperinceerror] = useState('');

    const [current_ctc, setcurrent_ctc] = useState('');
    const [current_ctcerror, setcurrent_ctcerror] = useState('');


    const [expected_ctc, setexpected_ctc] = useState('');
    const [expected_ctcerror, setexpected_ctcerror] = useState('');

    const [noticeperiod, setnoticeperiod] = useState('');
    const [noticeperioderror, setnoticeperioderror] = useState('');

    const [currentloc, setcurrentloc] = useState('');
    const [currentlocerror, setcurrentlocerror] = useState('');

    const [hometown, sethometown] = useState('');
    const [hometownerror, sethometownerror] = useState('');

    const [coverletter, setcoverletter] = useState('');
    const [coverlettererror, setcoverlettererror] = useState('');

    const [mention_empname, setmention_empname] = useState('');
    const [empnameerror, setempnameerror] = useState('');

    const [compref, setfcompref] = useState('no');
    const [have_experinced, setHaveExperince] = useState('no');


    function handleChange(event) {
        // console.log("file:" + event.target.files[0]);
        // console.log("filename:" + event.target.files[0].name)
        setfile(event.target.files[0]);
        setfilename(event.target.files[0].name);
        setfileerror("");
    }
    const handlename = event => {
        const regex = /^[A-Za-z\s]*$/;
        if(regex.test(event.target.value)){
            setfullname(event.target.value);
        }
        if (event.target.value.length == 0) {
            setfullname("");
        }
        setfullnameerror("");
    };
    const handleemail = event => {
        setemail(event.target.value);
        setemailerror("");
    };
    const handlemobile = event => {
        const re = /^[0-9\b]+$/;
        if (event.target.value.length < 11 && re.test(event.target.value)) {
            setmobile(event.target.value);
        }
        if (event.target.value.length == 0) {
            setmobile("");
        }
        setmobileerror("");
    };
    const handlequalification = event => {
        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setqualification(event.target.value);
        setqualificationerror("");
    };

    const handlelinkdin = event => {
        setlinkdin_url(event.target.value);
    }
    const handlegithub = event => {
        setgithub_url(event.target.value);
    }
    const handleotherwebsite = event => {
        setother_website(event.target.value);
    }

    const handleaboutself = event => {
        setaboutself(event.target.value);
        setaboutselferror("");
    }
    const handlecurrentcomp = event => {

        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setcurrent_comp(event.target.value);
        setcurrent_comperror("");
    }
    const handletotalyears = event => {

        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setexperince(event.target.value);
        setexperinceerror("");
    }
    const handlecurrentctc = event => {

        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setcurrent_ctc(event.target.value);
        setcurrent_ctcerror("");
    }
    const handlenoticeperiod = event => {
        //setnoticeperiod(event.target.value);
        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setnoticeperiod(event.target.value);
        setnoticeperioderror("");
    }
    const handleexpectedctc = event => {

        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setexpected_ctc(event.target.value);
        setexpected_ctcerror("");
    }
    const handlehometown = event => {
        //sethometown(event.target.value);
        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            sethometown(event.target.value);
        sethometownerror("");
    }
    const handlecoverletter = event => {
        setcoverletter(event.target.value);
        setcoverlettererror("");
    }
    const handlecurrentloc = event => {
        //setcurrentloc(event.target.value);
        const re = /^[a-zA-Z0-9!@&()-`.\s,/\"]*$/;
        if (re.test(event.target.value))
            setcurrentloc(event.target.value);
        setcurrentlocerror("");
    }
    const handleEmpName = event => {
        setmention_empname(event.target.value);
    }
    const handlecompref = event => {
        setfcompref(event.target.value);
    }
    const handleExperience = event => {
        setHaveExperince(event.target.value);
    }
    const observed = useRef(null);
    const observedctcdetails = useRef(null);
    const observedrefcurremp = useRef(null);
    const observedrefhaveexp = useRef(null);

    const handleClosePopup = () => {
        window.location.href = "/Careers";
    }

    const clicksubmitapp = async () => {

        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let nameflag = true; let emailflag = true; let mobileflag = true; let qualificationflag = true; let emailvalidflag = true; let fileflag = true;
        if (file == "") {
            fileflag = false;
            setfileerror("Please Upload Resume");

        }
        if (fullname == "") {
            nameflag = false;
            setfullnameerror("Please Enter Full Name");

        }
        if (email == "") {
            setemailerror("Please Enter email address");
            emailflag = false;


        }
        if (!re.test(email)) {
            setemailerror("Please Enter valid email address");
            emailvalidflag = false;
            //return false;

        }
        if (mobile == "") {
            setmobileerror("Please Enter Mobile number");
            mobileflag = false;
            //return false;

        }
        if (mobile.length != 10) {
            setmobileerror("Please Enter Valid Mobile number");
            mobileflag = false;
            //return false;

        }
        if (qualification == "") {
            setqualificationerror("Please Enter Qualification");
            qualificationflag = false;

        }
        let firstsection = false;
        if (fileflag && nameflag && emailflag && emailvalidflag && qualification && mobileflag) {
            firstsection = true;
        }
        else {
            window.scrollTo({
                top: observed.current.offsetTop,
                behavior: 'smooth',
            });
            return false;
        }

        let aboutselfflag = true; let currentcompflag = true; let totalyearsflag = true; let currentctcflag = true; let expectedctcflag = true;
        let noticeperiodflag = true; let currentlocflag = true; let hometownflag = true;

        // if (aboutself == "") {
        //     aboutselfflag = false;
        //     setaboutselferror("Please Enter About your self");

        // }
        if (current_comp == "") {
            setcurrent_comperror("Please Enter Current Company");
            currentcompflag = false;
        }
        if (experince == "") {
            setexperinceerror("Please Enter Total Years of Experince");
            totalyearsflag = false;
        }
        if (current_ctc == "") {
            setcurrent_ctcerror("Please Enter Current CTC");
            currentctcflag = false;
        }
        if (expected_ctc == "") {
            setexpected_ctcerror("Please Enter Expected CTC");
            expectedctcflag = false;
        }
        if (noticeperiod == "") {
            setnoticeperioderror("Please Enter Notice Period");
            noticeperiodflag = false;
        }
        // if (currentloc == "") {
        //     setcurrentlocerror("Please Enter Current Location");
        //     currentlocflag = false;
        // }
        // if (hometown == "") {
        //     sethometownerror("Please Enter Home Town");
        //     hometownflag = false;
        // }

        if (have_experinced == "yes") {
            if (currentcompflag && totalyearsflag && currentctcflag && expectedctcflag && noticeperiodflag) {
                //secondsection = true;
            }
            else {
                window.scrollTo({
                    top: observedrefhaveexp.current.offsetTop,
                    behavior: 'smooth',
                });
                return false;
            }
        }

        // let secondsection = false;
        if (aboutselfflag && currentlocflag && hometownflag) {
            // secondsection = true;
        }
        else {
            window.scrollTo({
                top: observedctcdetails.current.offsetTop,
                behavior: 'smooth',
            });
            return false;
        }
        if (compref == "yes") {
            if (mention_empname == "") {
                setempnameerror("Please Enter Current employees Name");
                window.scrollTo({
                    top: observedrefcurremp.current.offsetTop,
                    behavior: 'smooth',
                });
                return false;
            }
        }


        // if (have_experinced == "yes"){
        //     if (currentcompflag && totalyearsflag && currentctcflag && expectedctcflag && noticeperiodflag  ) {
        //         //secondsection = true;
        //     }
        //     else {
        //         window.scrollTo({
        //             top: observedrefhaveexp.current.offsetTop,
        //             behavior: 'smooth',
        //         });
        //         return false;
        //     } 
        // }

        var from_data = {
            "job_id": job_id, "filename": filename, "fullname": fullname, "email": email, "mobile": mobile, "qualification": qualification,
            "linkdin_url": linkdin_url, "github_url": github_url, "other_website": other_website, "aboutself": aboutself,
            "current_comp": current_comp, "experince": experince, "current_ctc": current_ctc, "expected_ctc": expected_ctc,
            "noticeperiod": noticeperiod, "currentloc": currentloc, "hometown": hometown, "compref": compref, "mention_empname": mention_empname,
            "coverletter": coverletter, "have_experinced": have_experinced,
        }
        const formData = new FormData();
        formData.append("formFile", file);
        formData.append("fileName", filename);
        try {
            const res = await axios.post("/api/Login/file", formData);

        } catch (ex) {

        }
        handleShow();
        setloadingshow(true);
        axios.post("/api/Login/CareerApplyJob", from_data)
            .then(function (response) {
                if (response.data.success === false) {
                    // handleShow("");
                    // alert("Data not submitted!!! Please Try Again")
                    return false;
                }
                else {

                    setloadingshow(false);
                }

            })
            .catch(function (response) {

            });


    };

    //useeffect 
    //useeffect 
    //useeffect 

    useEffect(() => {

        postData('./../api/Login/Career', { "job_id": job_id })
            .then((response) => {
                if (response.data != null && response.data.length > 0) {
                    setData(response.data);
                    setMapdata(response.data)
                    //console.log("data: ", data)
                    //setUniqueDepartment(Array.from(new Set(data.data.map(item => item.department))))
                }
                else { setData(null); }
            });
    }, []);


    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header

        });
        // console.log(response, "careerdata");
        return response.json(); // parses JSON response into native JavaScript objects

    }

    return (
        <>
            <section className="careerform-sc">
                <Container>
                    <Row>
                        <Col xl={12}>
                            {data && data.map(({ job_title, location, department, no_of_openings, qualification
                                , experince, profile, responsiblities }) => (
                                <div className="apply-sc">

                                    <h2 className="pageinnerhead">{job_title}</h2>
                                    <p>{location} /{department}  </p>
                                </div>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="careerform-main">
                <Container>
                    <Row>
                        <Col xl={12}>



                            <div ref={observed} className="careerform-pnl">
                                <h4>Submit Your Application</h4>

                                <div className="careerform-inner">
                                    <label>Resume/CV <sup>*</sup></label>
                                    <div className="file-input">
                                        <input type="file" name="file-input" id="file-input" accept=".pdf,.doc,.docx" onChange={handleChange} className="file-input__input" />
                                        <label className="file-input__label" for="file-input">
                                            <span><IoMdAttach /></span>
                                            <span>ATTACH Resume/CV</span>
                                        </label>

                                        <span>{fileerror != '' && <div className="errormsgnew">{fileerror}</div>} {filename != '' && <div className="errormsggreen">{filename}</div>} </span>

                                    </div>
                                </div>

                                <div className="careerform-inner">
                                    <label>FullName <sup>*</sup></label>
                                    <input type="text" value={fullname} onChange={handlename} name="name" autoComplete="off"></input>
                                    <span>{fullnameerror != '' && <div className="errormsgnew">{fullnameerror}</div>}</span>
                                </div>
                                <div className="careerform-inner">
                                    <label>Email <sup>*</sup></label>
                                    <input type="text" value={email} onChange={handleemail} name="email" autoComplete="off" ></input>
                                    <span>{emailerror != '' && <div className="errormsgnew">{emailerror}</div>}</span>
                                </div>
                                <div className="careerform-inner">
                                    <label>Mobile <sup>*</sup></label>
                                    <input type="text" value={mobile} onChange={handlemobile} name="mobile" autoComplete="off"></input>
                                    <span className="clsmargin10">{mobileerror != '' && <div className="errormsgnew">{mobileerror}</div>}</span>
                                </div>
                                <div className="careerform-inner">
                                    <label>Qualification <sup>*</sup></label>
                                    <input type="text" value={qualification} onChange={handlequalification} name="qualification" autoComplete="off"></input>
                                    <span>{qualificationerror != '' && <div className="errormsgnew">{qualificationerror}</div>}</span>
                                </div>
                            </div>
                            <div className="careerform-pnl">
                                <h4>Links</h4>
                                <div className="careerform-inner">
                                    <label>Linkedin URL</label>
                                    <input type="text" value={linkdin_url} onChange={handlelinkdin}></input>
                                </div>
                                <div className="careerform-inner">
                                    <label>Github URL </label>
                                    <input type="text" value={github_url} onChange={handlegithub}></input>
                                </div>
                                <div className="careerform-inner">
                                    <label>Other website</label>
                                    <input type="text" value={other_website} onChange={handleotherwebsite}></input>
                                </div>
                            </div>
                            <div className="careerform-pnl">
                                <h4>About Self </h4>
                                <div className="careerform-inner">
                                    <textarea cols="40" rows="4" value={aboutself} onChange={handleaboutself} name="aboutself" autoComplete="off">
                                    </textarea>
                                    {/* <span>{aboutselferror != '' && <div className="errormsgnew">{aboutselferror}</div>}</span> */}
                                </div>

                            </div>

                            <div className="careerform-inner" ref={observedrefhaveexp}>
                                <label className="labelExp">Have you Experienced?<sup>*</sup></label>
                                <form>
                                    <label className="custom-radio">Yes
                                        <input type="radio" value="yes" name="radio"  onChange={handleExperience}></input>
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="custom-radio">No
                                        <input type="radio" name="radio" value="no" onChange={handleExperience}></input>
                                        <span className="checkmark"></span>
                                    </label>
                                </form>

                                {have_experinced == "yes" && (<div className="careerform-pnl width-100">
                                    <h4>CTC Details</h4>
                                    <div className="careerform-inner">
                                        <label>Current Company <sup>*</sup></label>
                                        <input type="text" value={current_comp} onChange={handlecurrentcomp} name="current_comp" autoComplete="off"></input>
                                        <span>{current_comperror != '' && <div className="errormsgnew">{current_comperror}</div>}</span>
                                    </div>
                                    <div className="careerform-inner">
                                        <label>Total Years of Experience <sup>*</sup></label>
                                        <input type="text" value={experince} onChange={handletotalyears} name="experince" autoComplete="off"></input>
                                        <span>{experinceerror != '' && <div className="errormsgnew">{experinceerror}</div>}</span>
                                    </div>
                                    <div className="careerform-inner">
                                        <label>Current CTC (Fixed / Variables / Bonus / Stocks) <sup>*</sup></label>
                                        <input type="text" value={current_ctc} onChange={handlecurrentctc} name="current_ctc" autoComplete="off"></input>
                                        <span>{current_ctcerror != '' && <div className="errormsgnew">{current_ctcerror}</div>}</span>
                                    </div>
                                    <div className="careerform-inner">
                                        <label> Expected CTC <sup>*</sup></label>
                                        <input type="text" value={expected_ctc} onChange={handleexpectedctc} name="expected_ctc" autoComplete="off"></input>
                                        <span>{expected_ctcerror != '' && <div className="errormsgnew">{expected_ctcerror}</div>}</span>
                                    </div>
                                    <div className="careerform-inner">
                                        <label>Notice Period - (If currently serving kindly mention your Last Working Date) <sup>*</sup></label>
                                        <input type="text" value={noticeperiod} onChange={handlenoticeperiod} name="noticeperiod" autoComplete="off"></input>
                                        <span>{noticeperioderror != '' && <div className="errormsgnew">{noticeperioderror}</div>}</span>
                                    </div>

                                </div>)}
                            </div>
                            {/* <div className="careerform-pnl width-100" ref={observedctcdetails}>
                                <div className="careerform-inner">
                                    <label>Current Location<sup>*</sup></label>
                                    <input type="text" value={currentloc} onChange={handlecurrentloc} name="currentloc" autoComplete="off"></input>
                                    <span>{currentlocerror != '' && <div className="errormsgnew">{currentlocerror}</div>}</span>
                                </div>
                                <div className="careerform-inner">
                                    <label> Home Town <sup>*</sup></label>
                                    <input type="text" value={hometown} onChange={handlehometown} name="hometown" autoComplete="off"></input>
                                    <span>{hometownerror != '' && <div className="errormsgnew">{hometownerror}</div>}</span>
                                </div>
                            </div> */}
                            <div ref={observedrefcurremp} className="careerform-pnl width-100">
                                <h4>Referral</h4>
                                <div className="careerform-inner">
                                    <label>Have you been referred by any of our current employees? <sup>*</sup></label>
                                    <form>
                                        <label className="custom-radio">Yes
                                            <input type="radio" value="yes" name="radio" onChange={handlecompref}></input>
                                            <span className="checkmark"></span>
                                        </label>
                                        <label className="custom-radio">No
                                            <input type="radio" name="radio" value="no" onChange={handlecompref}></input>
                                            <span className="checkmark"></span>
                                        </label>
                                    </form>
                                </div>
                                {compref == "yes" && (<div className="careerform-inner">
                                    <label>If Yes, please mention the name of the employee. <sup>*</sup></label>
                                    <input type="text" value={mention_empname} name="mention_empname" onChange={handleEmpName} autoComplete="off"></input>
                                    <span>{empnameerror != '' && <div className="errormsgnew">{empnameerror}</div>}</span>
                                </div>)}
                            </div>
                            <div className="careerform-pnl">
                                <h4>Additional Information</h4>
                                <div className="careerform-inner">
                                    <textarea cols="40" rows="4" value={coverletter} onChange={handlecoverletter} name="coverletter" autoComplete="off">
                                        Add a cover letter or anything else you want to share.
                                    </textarea>
                                    <span>{coverlettererror != '' && <div className="errormsgnew">{coverlettererror}</div>}</span>
                                </div>
                            </div>

                            <div className="submit-btn">

                                <button className="Login-Button btnnew" onClick={() => clicksubmitapp()}>SUBMIT APPLICATION</button>
                            </div>

                            <Modal className="success-modal" show={show} >
                                {loadingshow ? <div className="textcenter">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <Modal.Body className="model_popup"> Processing....</Modal.Body>
                                </div> :
                                    <div>
                                        <Modal.Body className="textsucess"> Successfully Submitted.!</Modal.Body>
                                        <button className="btnClose" onClick={handleClosePopup}>Close</button>

                                    </div>
                                }
                            </Modal>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default CareerInner;